<template>
  <div class="navbar-container mt-n1 mb-1">
    <div class="powered-by" v-if="showSchickHeader">
      <div class="schick">
        <h2 class="text-hide">Schick</h2>
      </div>
    </div>
    <b-navbar toggleable="lg" type="dark" variant="info" :class="[isCompact ? 'mt-n1' : '']">
      <b-navbar-brand href="/home" class="ml-4"><span>&nbsp;</span></b-navbar-brand>
      <b-navbar-brand href="#" class="text-center mr-0">
        SITEACCESS<span>pro</span>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <li class="nav-item">
            <router-link tag="a" to="/home" class="nav-link">Home</router-link>
          </li>
          <!-- <li class="nav-item">
            <router-link tag="a" to="/sites" class="nav-link">Sites</router-link>
          </li> -->
          <li class="nav-item">
            <router-link tag="a" to="/sign-ins" class="nav-link">Sign-Ins</router-link>
          </li>
          <li class="nav-item">
            <a href="https://forms.microsoft.com/r/mm7nKHXfPT" class="nav-link" target="_blank" rel="noopener noreferrer">Leave Request</a>
          </li>
          <li class="nav-item">
            <a href="https://outlook.office.com/mail/" class="nav-link" target="_blank" rel="noopener noreferrer">Schick Email</a>
          </li>
          <li class="nav-item">
            <a href="https://mobile.civilx.co.nz/" class="nav-link" target="_blank" rel="noopener noreferrer">CivilX Mobile</a>
          </li>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div v-if="!isCompact && loggedInAs" class="logged-in-as left-0">
      <span>Signed in as: {{ loggedInAs }}</span>
    </div>
  </div>
</template>

<style lang="scss">
  @import "../assets/main.scss";
</style>

<script>
import * as auth from '@/lib/auth';

export default {
  name: 'Navbar',
  props: ['isCompact'],
  data() {
    return {
      name: '',
    };
  },
  computed: {
    showSchickHeader() {
      return !this.isCompact;
    },
    loggedIn() {
      return !!(auth.data.user || auth.data.claims);
    },
    loggedInAs() {
      if (auth.data && auth.data.claims && auth.data.claims.given_name) {
        return `${auth.data.claims.given_name} ${auth.data.claims.family_name}`;
      }
      if (auth.data && auth.data.claims) {
        return auth.data.claims.name;
      }
      if (auth.data && auth.data.user) {
        return auth.data.user.username;
      }
      return this.name;
    },
  },
};
</script>
